<style lang="stylus" scoped>
@import '../cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF; 
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-search .map-title {
  padding-bottom: 20px;
  margin-bottom: 16px;
  height: auto;
  border-radius: 5px;
}

.map-data {
  border-radius: 5px;
  margin-bottom: 20px;
}

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-search .map-title {
  padding-bottom: 20px;
  margin-bottom: 16px;
  height: auto;
  border-radius: 5px;
}

.map-data {
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
<template>
  <div class="home-main">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="map-search" >
      <div class="map-title">
        <el-row>
          <el-col :span="16">
            <Times :changeType="changeType" :tab="datatype"/>
            <div style="line-height:30px;margin-left:-10px;font-size:14px;">
              <span class="color2 pointer">全国</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="t-r" style="padding-top:55px;line-height:50px;">
              <!-- <span v-show="ceshi">这里添加一个标签</span> -->
              <el-date-picker
                :clearable="false"
                v-model="timeSection"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="change"
              ></el-date-picker>
              <!-- @focus="focus"
              @blur="blur"-->
              <br>
              <!--  -->
              <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
              
              <SearchBtn/>
              <!-- <el-button  style="margin-left:20px;" @click="goBack(-1)">返回上级</el-button> -->
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <TableDate :dataAll="countryDate" :loading="loading"/> -->
    <template v-if="tableDatas.length>0">
      <TableDate
        v-for="(item,index) in tableDatas"
        :isShow="index==0?true:false"
        :dataAll="item"
        :name="item.name"
        :key="item.name"
        :toDetail="toDetail"
        :code="item.code"
        :loading="loading"
      />
    </template>
  </div>
</template>
<script>
import SearchBtn from '../components/searchBtn' //跳转到搜索页
import Times from '../components/header' //快速选择时间
import TableDate from '../components/tableDate' //表格数据
import http from '@/api/consump.js' //请求汇总
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
export default {
  data() {
    return {
      hideExport:hideExport,
      mark: false, //遮罩层开关
      timeSection: [
        new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 1 * 24 * 3600 * 1000) * 1
      ],
      progressNum: 0, //下载进度条进度
      tableDatas: [],
      datatype: '1', //快速选择时间类型
      total: [], //合计
      loading: true,
      countryDate: {}, //全国数据
      pickerOptions: {
        onPick() {
          //console.log('触发了函数')
        }
      }
      // ceshi: false // 时间选择器提示框
    }
  },
  created() {
    this.timeSection = this.$route.query.times
      ? JSON.parse(this.$route.query.times)
      : this.timeSection
    this.datatype = this.$route.query.timeTab
      ? this.$route.query.timeTab + ''
      : this.datatype // 默认时间
  },
  mounted() {
    this.init()
  },
  watch: {},
  methods: {
    // blur() {
    //   console.log('失去了焦点')
    //   this.ceshi = false
    // },
    // focus() {
    //   console.log('获取了焦点')
    //   this.ceshi = true
    // },
    change() {
      let that = this
      that.loading = true
      http.allData({ 
        section: that.timeSection,
        type: that.datatype
      }).then(e => {
        that.countryDate = e.data
      })
      that.initProvince()
      this.datatype = '1'
    },
    init() {
      // let that = this
      // that.loading = true
      // http.allData({ section: that.timeSection, type: that.datatype })
      //   .then(e => {
      //     that.countryDate = e.data
      //     that.timeSection = e.data.timeSection.split(',').map(e => e * 1)
      //   })
      this.initProvince()
    },
    initProvince() {
      let that = this
      http.allProvince({ section: that.timeSection, type: that.datatype })
        .then(e => {
          that.tableDatas = [...e.data]
          that.timeSection = e.timeSection.split(',').map(e => e * 1)
          that.loading = false
        })
    },
    exportDate() {
      //导出
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      let times
      times = setInterval(function() {
        http.progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      window.location.assign(
        http.countryData({
          start: that.timeSection[0],
          end: that.timeSection[1],
          reqId
        })
      )
    },
    toDetail({ name, code }) {
      if(code==null||code=='')return false;
      let that = this
      this.$router.push({
        name: 'consumpProvince',
        query: {
          times: JSON.stringify(that.timeSection),
          provinceName: name,
          provinceCode: code,
          timeTab: that.datatype //时间类型
        }
      })
    },
    goBack(num) {
      this.$router.go(num)
    },
    changeType(type) {
      this.datatype = type
      this.init()
    }
  },
  components: {
    Times,
    SearchBtn,
    TableDate
  }
}
</script>
